module.exports = __webpack_public_path__ + "img/beforeandafter1.ac6fe8a0.png";